module.exports = __webpack_public_path__ + "img/manufacturer_god.aad89a92.svg";